export default __webpack_public_path__ + "static/media/icon-filetype-pdf.a0188005.svg";